"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalInterest = exports.TotalInterestFormula = void 0;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of TotalInterest formala implementation names
 */
var TotalInterestFormula;
(function (TotalInterestFormula) {
    TotalInterestFormula[TotalInterestFormula["DEFAULT"] = 0] = "DEFAULT";
})(TotalInterestFormula = exports.TotalInterestFormula || (exports.TotalInterestFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getTotalInterest(formula) {
    switch (formula) {
        default:
            return default_totalInterest;
    }
}
exports.getTotalInterest = getTotalInterest;
///////////////////////////
// Function Implementations
///////////////////////////
const default_totalInterest = (totalInterest) => {
    // ensure valid argument types
    if (Array.isArray(totalInterest)) {
        let sumTotalInterest = 0;
        for (let x = 0; x < totalInterest.length; x++) {
            if (typeof totalInterest[x] !== 'number') {
                sumTotalInterest = NaN;
                break;
            }
            sumTotalInterest += totalInterest[x];
        }
        return (0, general_formulas_1.toFixedNumber)(sumTotalInterest, 2);
    }
    return NaN;
};
//# sourceMappingURL=total-interest.js.map